import { FieldConfig, FieldDataTypes } from '@hidat/huijs-common';
import { ResourceSystemFields } from '@hidat/huijs-resource';

/**
 * Splixer Field Dictionary
 * A bunch of field definitions used by multiple resources.
 * Would love to figure out a way to do this as a typesafe static of some sort....
 */
export const splixerFieldConfigs = {
  intId: ResourceSystemFields.intId,
  guidId: ResourceSystemFields.guidId,
  uid: new FieldConfig('uid', FieldDataTypes.UID),
  status: ResourceSystemFields.status.setRequired(true).freeze(),

  name: ResourceSystemFields.name,
  tagLine: new FieldConfig('tagLine').freeze(),
  description: new FieldConfig('description').freeze(),
  imageUrl: new FieldConfig('imageUrl').freeze(),
  branding: new FieldConfig('branding', FieldDataTypes.HASH).freeze(),
  duration: new FieldConfig('duration', FieldDataTypes.NUMBER).freeze(),

  /* Foreign Key ID's */
  tenantId: new FieldConfig('tenantId', FieldDataTypes.UID).freeze(),
  stationId: new FieldConfig('stationId', FieldDataTypes.INTEGER).freeze(),
  channelId: new FieldConfig('channelId', FieldDataTypes.INTEGER).freeze(),
  hostId: new FieldConfig('hostId', FieldDataTypes.INTEGER).freeze(),
  programId: new FieldConfig('programId', FieldDataTypes.INTEGER).freeze(),
  showId: new FieldConfig('showId', FieldDataTypes.INTEGER).freeze(),
  mixId: new FieldConfig('mixId', FieldDataTypes.INTEGER).freeze(),
  remoteId: new FieldConfig('remoteId', FieldDataTypes.INTEGER).freeze(),
  remoteCode: new FieldConfig('remoteCode').freeze(),

  playbackSessionId: new FieldConfig(
    'playbackSessionId',
    FieldDataTypes.INTEGER,
  ).freeze(),
  instanceId: new FieldConfig('instanceId', FieldDataTypes.INTEGER).freeze(),
  listenerId: new FieldConfig('listenerId', FieldDataTypes.INTEGER).freeze(),
  contentPathId: new FieldConfig(
    'contentPathId',
    FieldDataTypes.INTEGER,
  ).freeze(), // mixId in future?
};

export const splixerSystemFields = [
  ResourceSystemFields.createdAt,
  ResourceSystemFields.updatedAt,
];
